import React from 'react'

const ContactFilterSkeleton = ({ isLast }: { isLast: boolean }) => (
  <>
    <div className={`w-full px-4 ${!isLast && 'border-b-text-secondary/30 border-b pb-3'}`}>
      <div
        className={
          'bg-skeleton-primary flex animate-pulse items-center gap-3 rounded-md text-transparent'
        }
      >
        .
      </div>
    </div>
  </>
)

export default ContactFilterSkeleton
